export default "__VITE_ASSET__4b39b6b7__"